import { render, staticRenderFns } from "./Athlete.vue?vue&type=template&id=1251331e&scoped=true"
import script from "./Athlete.vue?vue&type=script&lang=js"
export * from "./Athlete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1251331e",
  null
  
)

export default component.exports